<script setup lang="ts">
import type { PropType } from "@vue/runtime-core";
import { RoamingCountryStruct } from "@/struct/RoaminStruct";
import { defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  countersList: {
    type: Object as PropType<RoamingCountryStruct[]>,
    required: true,
  },
  isSelectType: {
    type: Boolean,
    default: false,
  },
  uuidActive: {
    type: String,
    default: "",
  },
});
const emits = defineEmits(["select"]);
const { t } = useI18n();

const selectCountry = (country: RoamingCountryStruct) => {
  if (props.isSelectType) {
    emits("select", country);
  }
};
</script>

<template>
  <div
    class="roaming-counters__window"
    :class="{ '--type-select': isSelectType }"
  >
    <div class="roaming-counters__window-wrapper">
      <div v-if="countersList.length" class="roaming-counters__window-list">
        <div
          v-for="(item, index) in countersList"
          :key="index"
          @click="selectCountry(item)"
          class="roaming-counters__window-item"
          :class="{ '--active': uuidActive === item.uuid }"
        >
          <img
            v-if="item.img_url"
            class="roaming-counters__window-item__image"
            :src="item.img_url"
            :alt="t('roaming.list.flagAlt')"
          />
          <div
            v-else
            class="roaming-counters__window-item__image --empty"
          ></div>
          <span>{{ item.country_name_ru }}</span>
        </div>
      </div>
      <div v-else class="roaming-counters__window-empty">
        <span>{{ t("roaming.list.empty") }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/colors";

.roaming-counters__window {
  padding: 0 2px;
  width: 100%;
  border-radius: 16px;
  box-shadow: 6px 6px 10px 0px #00000008, -6px 0px 10px 0px #00000008;
  background: var(--color-white);
  z-index: 2;
  overflow: hidden;
  &.--type-select {
    .roaming-counters__window-list {
      max-height: 164px;
    }
    .roaming-counters__window-item {
      cursor: pointer;
      &:not(.--active):hover {
        background-color: var(--color-bg-primary);
      }
    }
  }
  &-wrapper {
    overflow: hidden;
    height: fit-content;
  }
  &-list {
    max-height: 460px;
    overflow-y: auto;
    padding: 10px 6px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--color-secondary);
      border-radius: 20px;
    }
    &::-webkit-scrollbar-button {
      opacity: 0;
      height: 5px;
    }
  }
  &-empty {
    padding: 10px 6px;
  }
  &-item {
    min-height: 33px;
    padding: 6px 10px;
    display: flex;
    gap: 8px;
    align-items: center;
    border-radius: 8px;
    transition: background-color 0.2s;

    &.--active {
      background-color: var(--color-grey-blue);
    }
    &__image {
      width: 20px;
      &.--empty {
        border-radius: 50%;
        background-color: var(--color-bg-primary);
      }
    }
  }
}
</style>
